import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import ColorPicker from 'rc-color-picker';

import 'rc-color-picker/assets/index.css';

class BasicInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleChange = this._handleChange.bind(this);
  }

  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    help: PropTypes.string,
    noFormGroup: PropTypes.bool,
    required: PropTypes.bool,
    ajaxErrors: PropTypes.object,
    setFieldValue: PropTypes.func,
    type: PropTypes.string
  };

  _handleChange(value) {
    this.props.setFieldValue(this.props.name, value.color);
  }

  render() {
    const {
      touched,
      errors,
      values,
      name,
      type,
      label,
      help,
      noFormGroup,
      required,
      ajaxErrors
    } = this.props;

    const className = this.props.className ? this.props.className : '';

    return (
      <div
        className={
          (touched[name] && errors[name]) ||
          (ajaxErrors && !touched[name] && ajaxErrors[name])
            ? (noFormGroup ? '' : 'form-group m-form__group ') + 'has-danger'
            : noFormGroup
            ? ''
            : 'form-group m-form__group '
        }
      >
        {label && (
          <label htmlFor={name}>
            <Trans>{label}</Trans> {required ? '*' : ''}
          </label>
        )}
        <ColorPicker
          className={'form-control m-input wrapped-color-picker' + className}
          style={{ zIndex: 9999 }}
          type={type}
          name={name}
          id={name}
          onChange={this._handleChange}
          required={!!required}
          color={values[name]}
          enableAlpha={false}
        />
        {help && (
          <span className="m-form__help">
            <Trans>{help}</Trans>
          </span>
        )}
        {touched[name] && errors[name] && (
          <div className="form-control-feedback">
            <Trans>{errors[name]}</Trans>
          </div>
        )}
        {ajaxErrors && !touched[name] && ajaxErrors[name] && (
          <div className="form-control-feedback">
            <Trans>{ajaxErrors[name]}</Trans>
          </div>
        )}
      </div>
    );
  }
}

export default BasicInput;
